import React, { useEffect } from 'react';
import { Container } from '@fiverr-private/layout_components';
import {
    IdentificationContextProvider,
    useOnceBeforeRenderOnClient,
    SIGNING_FLOW_TYPE_MAP,
} from '@fiverr-private/identification_core';
import { globalBigQueryReporter, globalGrafanaReporter } from '../../events';
import { DEFAULT_STEP_ID } from '../../constants/stepId';
import { StepsContextProvider } from '../StepsContext';
import { SignUpContextProvider } from '../SignUpContext';
import { ActiveStep } from '../ActiveStep';
import { type IdentificationFormProps } from './IdentificationForm.types';

export const IdentificationForm: React.FC<IdentificationFormProps> = ({
    redirectUrl = '',
    mode = 'sign_up',
    isModal = false,
    isModalOpen = false,
    isSticky = false,
    skipQuestionnaire = true,
    skipActivation = false,
    isCodeActivationSkippable = true,
    closeModal,
    isSocialFlow = false,
    blockedActionType,
    stepId = DEFAULT_STEP_ID,
    email = '',
    username = '',
    source,
    bigQueryEnrichment = {},
    afterSigningSuccess,
    onStepIdChange,
    inBeetlesMigrateSignupWebRollout,
    inBeetlesMigrateSigninWebRollout,
    inBeetlesMigrateSocialSignUpRollout,
}) => {
    useOnceBeforeRenderOnClient(() => {
        globalBigQueryReporter.enrichContext(
            {
                mode,
                source,
                funnel: 'business',
                provider: 'standard',
                reason: 'user_trigger',
                experience: 'Identification',
                flow: mode === 'sign_up' ? SIGNING_FLOW_TYPE_MAP.signUp : SIGNING_FLOW_TYPE_MAP.signIn,
                ...bigQueryEnrichment,
            },
            { resetState: true }
        );
    });

    useEffect(() => {
        globalBigQueryReporter.send('identification.show');
        globalGrafanaReporter.count('identification.%{platform}.show');
    }, []);

    return (
        <IdentificationContextProvider
            isSticky={isSticky}
            isSocialFlow={isSocialFlow}
            isModal={isModal}
            isModalOpen={isModalOpen}
            closeModal={closeModal}
            skipQuestionnaire={skipQuestionnaire}
            skipActivation={skipActivation}
            isCodeActivationSkippable={isCodeActivationSkippable}
            initialMode={mode}
            redirectUrl={redirectUrl}
            initialEmail={email}
            initialUsername={username}
            blockedActionType={blockedActionType}
            afterSigningSuccess={afterSigningSuccess}
            inBeetlesMigrateSignupWebRollout={inBeetlesMigrateSignupWebRollout}
            inBeetlesMigrateSigninWebRollout={inBeetlesMigrateSigninWebRollout}
            inBeetlesMigrateSocialSignUpRollout={inBeetlesMigrateSocialSignUpRollout}
        >
            <Container overflow="auto" height={{ default: '100%', sm: '645px' }} width="100%">
                <StepsContextProvider stepId={stepId} onStepIdChange={onStepIdChange}>
                    <SignUpContextProvider>
                        <ActiveStep />
                    </SignUpContextProvider>
                </StepsContextProvider>
            </Container>
        </IdentificationContextProvider>
    );
};
